import AWS from 'aws-sdk/global';
import 'aws-sdk/clients/firehose';
import 'aws-sdk/lib/credentials/cognito_identity_credentials';
import {dateConverter} from '../utils/helpers/dateConverter';

import chunk from 'lodash/chunk';
import isEqual from 'lodash/isEqual';
import cloneDeep from 'lodash/cloneDeep';

import {reportError} from "@/utils/helpers/health-monitoring";

import {
    TYPES,
    STATISTICS_VALIDATION
} from '@/utils/constants/statistics-event';

export const sendEvent = ({ getters, dispatch }, data) => {
    if(!getters.isTerminalStatisticsEnabled || !isStatisticsEnabled())
    {
        return Promise.resolve();
    }

    const eventData = eventValidation({
        ...getters.getBaseEventData,
        ...getRuntimeEventData(),
        ...data
    });

    if( !isOnline() ) {
        addOfflineEvent(eventData);
        return Promise.resolve();
    }

    if(!areAwsCredentialOk()){
        dispatch('registerAWSIdentity');
    }

    console.debug('StatisticsEvent:', eventData);
    const firehose = new AWS.Firehose();

    const params = {
        DeliveryStreamName: process.env.VUE_APP_STATISTICS_GENERAL_STREAM,
        Record: {
            Data: JSON.stringify(eventData),
        },
    };

    return firehose.putRecord(params, (err, d) => {
        if (err){
            console.error(err);
            
            if(err.code !== 'InvalidSignatureException') {
                reportError(err);
            }

            if(err.code == 'CredentialsError'  && isOnline()) {
                dispatch('registerAWSIdentity');
            }

            if(err.code == 'ServiceUnavailableException' ||
                err.code == 'NetworkingError' ||
                err.code == 'CredentialsError'
            ) {
                addOfflineEvent(eventData);
            }
        } else if(getOfflineEvents()) {
            dispatch('sendEvents');
        }
    });
};

export const sendEvents = ({ getters }) => {

    if(!isOnline() || !getters.isTerminalStatisticsEnabled || !isStatisticsEnabled())
    {
        return Promise.resolve();
    }

    const events = getOfflineEvents()
    if(!events) return Promise.resolve();

    console.debug('StatisticsEvents:', events);
    const firehose = new AWS.Firehose();

    const separeteEvents = chunk(events, 500)
    return Promise.all(separeteEvents.map(events => {
        const params = {
            DeliveryStreamName: process.env.VUE_APP_STATISTICS_GENERAL_STREAM,
            Records: [
                ...events.map(event => ({
                    Data: JSON.stringify(event),
                }))
            ],
        };
        return firehose.putRecordBatch(params, (err, d) => {
            if (err){
                console.error(err);
                reportError(err)
            } else {
                clearOfflineEvents();
            }
        });
    }));
};

function getRuntimeEventData(){
    return {
        datetime: dateConverter(),
        url:document.location.href,
    };
}

function isStatisticsEnabled(){
    return process.env.VUE_APP_STATISTICS_ENABLED === 'true';
}

function isOnline(){
    return window.navigator.onLine;
}

function addOfflineEvent(event) {
    const storageOfflineEvents = localStorage?.getItem('offlineEvents');

    if(storageOfflineEvents) {
        const parseEvents = JSON.parse(storageOfflineEvents)
        const isNewEvent = parseEvents.find(storageEvent => isEqual(storageEvent, event))
        if(!isNewEvent) {
            localStorage?.setItem('offlineEvents', JSON.stringify([...JSON.parse(storageOfflineEvents), event]));
        }
    } else {
        localStorage?.setItem('offlineEvents', JSON.stringify([event]));
    }
}

function clearOfflineEvents() {
    localStorage?.removeItem('offlineEvents');
}

function getOfflineEvents() {
    const events = localStorage?.getItem('offlineEvents');
    return events ? JSON.parse(events) : false;
}

function eventValidation(event) {
    const validationEvent = cloneDeep(event)
    Object.entries(validationEvent).forEach(([key, value]) => {
        const valueLength = value?.length || value?.toString()?.length || 0;
        switch (STATISTICS_VALIDATION[key].type) {
            case TYPES.INT:
                if(value < STATISTICS_VALIDATION[key].minValue || value > STATISTICS_VALIDATION[key].maxValue)
                    validationEvent[key] = value.slice(0, 8)
            case TYPES.VARCHAR:
                if(valueLength > STATISTICS_VALIDATION[key].maxLength)
                    validationEvent[key] = value?.toString()?.slice(0, STATISTICS_VALIDATION[key].maxLength - 1)
            default:
                break
        }

    })
    return validationEvent
}

export const sendSearchEvent = ({ dispatch, getters}, searchParams) => {
    const event = {
        event_category:"ui",
        event:"search",
        ...searchParams
    };
    dispatch('sendEvent', event)
};

export const sendCategoryClickEvent = ({ dispatch, getters}, category ) => {
    const cat = typeof category === 'number' ? getters.getListItem(category) : category;
    if(cat)
    {
        dispatch('sendEvent', {
            event_category: "ui",
            event: "click",

            target: 'category',
            source_id: cat.root_id,
            target_id: cat.id,
        });
    }
};

export const sendObjectClickEvent = ({ dispatch, getters}, object ) => {
    const obj = typeof object === 'number' ? getters.getObject(object) : object
    if(obj)
        dispatch('sendEvent', {
            event_category:"ui",
            event:"click",

            target:'object',
            target_type: obj.type,
            target_id: obj.id,
        })
}

export const sendServicesClickEvent = ({ dispatch, getters}, object ) => {
    const services = typeof object === 'number' ? getters.getObject(object) : object

    if(services)
        dispatch('sendEvent', {
            event_category:"ui",
            event:"click",
            source_id: services.root_id,
            target: 'category',
            target_type: 'services',
            target_id: services.id,
        })
}

export const sendObjectHoverEvent = ({ dispatch, getters}, object ) => {
    const obj = typeof object === 'number' ? getters.getObject(object) : object
    if(obj)
        dispatch('sendEvent', {
            event_category:"ui",
            event:"hover",

            target:'object',
            target_type: obj.type,
            target_id: obj.id,
        })
}

export const sendGuideEvent = ({ dispatch, getters}, {guide, params} ) => {
    const obj = guide?.to?.id ? getters.getObject(guide.to.id) : {}

    dispatch("sendEvent", {
        tid: guide.from.id || guide.from,
        event_category: "ui",
        event: "guide",
        target: 'object',
        target_type: obj.type,
        target_id: guide.to.id || guide.to,
        value1: 'fast',
        ...params
    })
};

export const sendGuideStepEvent = ({ state, dispatch, getters}, { stepIndex, eventCategory }) => {
    const obj = getters.getObject(_.get(state.activePath,'to'))

    const eventData = {
        tid: _.get(state.activePath,'from.id') || _.get(state.activePath,'from'),
        event_category: eventCategory || 'ui',
        event: "guide_step",
        target: 'object',
        target_type: obj.type,
        target_id: _.get(state.activePath,'to.id') || _.get(state.activePath,'to'),
        value1: _.get(state.activePath, 'steps.length', 0) - stepIndex - 1,
        value2: _.get(state.activePath, `steps[${stepIndex}].type`, 'undefined').toLowerCase(), //step type
    }
    dispatch("sendEvent", eventData)
}

export const registerAWSIdentity = () =>{
    // Registrer cognito identy
    if(isOnline()){
        try{
            AWS.config.region = 'eu-central-1'; // Region
            AWS.config.credentials = new AWS.CognitoIdentityCredentials({
                IdentityPoolId: process.env.VUE_APP_STATISTICS_IDENTY_POOL_ID,
            });
            return true;
        }
        catch(e){
            console.error(e);
            reportError(e);
        }
    }
    return false;
}
function hasAwsCredentials(){
    !areAwsCredentialOk() && isOnline() && registerAWSIdentity();
    return areAwsCredentialOk();
}

function areAwsCredentialOk(){
    return Boolean(AWS.config.credentials);
}
